module.exports = __webpack_public_path__ + "32f38bf46c15f9f71ab8129ddc228afa.jpg";